import { render, staticRenderFns } from "./RegisterPengalaman.vue?vue&type=template&id=50a39f4a&scoped=true&"
import script from "./RegisterPengalaman.vue?vue&type=script&lang=js&"
export * from "./RegisterPengalaman.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPengalaman.vue?vue&type=style&index=0&id=50a39f4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a39f4a",
  null
  
)

export default component.exports